import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import img from '../views/img.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/img',
    name: 'img',
    component: img
  },

]

const router = new VueRouter({
  routes
})

export default router
